import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reloadRpTables } from '@legacy/screens/ResourcePlanner/helper/reloadRpTables';
import { deleteFetch } from '@legacy/utils/fetcher';
import { formatUrl } from '@legacy/utils/url';
import { TDeleteWorkItemRelationshipReq } from './deleteWorkItemRelationshipAPI.types';

const DELETE_WORK_ITEM_RELATIONSHIP_URL_PATH =
  '/api/v2/resource-planner/work-item-relationship';
const DELETE_WORK_ITEM_RELATIONSHIP_KEY = 'deleteRelationship';

const deleteWorkItemRelationship = ({
  workItemId,
  workItemSourceReferenceId,
  workItemType,
  resourceId,
  resourceSourceReferenceId,
  resourceType,
}: TDeleteWorkItemRelationshipReq) =>
  deleteFetch({
    path: formatUrl(DELETE_WORK_ITEM_RELATIONSHIP_URL_PATH),
    key: DELETE_WORK_ITEM_RELATIONSHIP_KEY,
    body: JSON.stringify({
      workItemId,
      workItemSourceReferenceId,
      workItemType,
      resourceId,
      resourceSourceReferenceId,
      resourceType,
    }),
  });

export const useDeleteWorkItemRelationship = (onSuccess?: () => void) => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: deleteWorkItemRelationship,

    onSuccess: () => {
      reloadRpTables(qc);
      onSuccess?.();
    },
  });
};
